export default __webpack_public_path__ + "static/media/Group48.e0a925b3.svg";